import NotRegisteredWithGP from './NotRegisteredWithGP.vue';

export default {
    NotRegisteredWithGP
}